/**
 * scripts.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import {preventDefault} from "ol/events/Event";
import {display} from "@splidejs/splide/src/js/utils";


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.saipem_theme = {
    attach: function (context, settings) {

        once('hide-in-safari', '.hide-in-safari', context).forEach(
          function (element) {
            let userAgent = navigator.userAgent;
            console.log(userAgent);


            if(userAgent.match(/safari/i)){
              $(element).hide();
            }
          }
        );

        once('cta-yards', '.node--type-landing-page .view-display-id-block_2', context).forEach(
          function (element) {

            function getQuerystringParameters() {
              // Ottenere la querystring dall'URL
              let queryString = window.location.search.substring(1);

              // Dividere la querystring in coppie di chiavi e valori
              let queryParams = queryString.split("&");

              // Creare un oggetto per contenere i parametri
              let params = {};

              // Iterare attraverso le coppie di chiavi e valori e inserirle nell'oggetto
              for (let i = 0; i < queryParams.length; i++) {
                let pair = queryParams[i].split("=");
                let key = decodeURIComponent(pair[0]);
                let value = pair.length > 1 ? decodeURIComponent(pair[1]) : null;

                // Aggiungere la coppia chiave-valore all'oggetto
                if (key !== "") {
                  if (params[key]) {
                    // Se la chiave esiste già, trasformarla in un array
                    if (!Array.isArray(params[key])) {
                      params[key] = [params[key]];
                    }
                    params[key].push(value);
                  } else {
                    params[key] = value;
                  }
                }
              }

              // Restituire l'oggetto contenente i parametri
              return params;
            }

            // Esempio di utilizzo
            let queryParameters = getQuerystringParameters();
            if (typeof queryParameters.tab !== 'undefined') {
              if (queryParameters.tab == 'cantieri' || queryParameters.tab == 'yards') {
                $(document).find('.saipem--container .saipem--tabs ul li:last > a').each (
                  function(k,elem) {
                    if (typeof $(elem)[0] !== 'undefined') $(elem)[0].click();
                  }
                );
              }
            }
          }
        );


        once('focus-full-width','.paragraph--type--focus-full-width .carousel',context).forEach(
          function (element) {

            let maxslides_visible = 6;

            for(let i=0;i<$(element).find('.carousel-indicators>li').length;i++){
              if(i+1>maxslides_visible){
                $(element).find('.carousel-indicators>li').eq(i).hide();
              }
              else
              {
                $(element).find('.carousel-indicators>li').eq(i).show();
              }
            }


            $(element).on('slid.bs.carousel', function () {
              let count = $(element).find('.carousel-indicators>li').length;

              let maxslides_visible = 6;
              if(count>maxslides_visible)
              {
                for(let i=0;i<$(element).find('.carousel-indicators>li').length;i++){
                  if(i+1>maxslides_visible){
                    $(element).find('.carousel-indicators>li').eq(i).hide();
                  }
                }
                let current = $(element).find('.carousel-indicators>li.active').data('bs-slide-to');

                if(current+1>=maxslides_visible){

                    for(let i=0;i<$(element).find('.carousel-indicators>li').length;i++){
                      if(i<=count-1-maxslides_visible){
                        $(element).find('.carousel-indicators>li').eq(i).hide();
                      }
                      else
                      {
                        $(element).find('.carousel-indicators>li').eq(i).show();
                      }
                    }


                }
                else
                {
                  for(let i=0;i<$(element).find('.carousel-indicators>li').length;i++){
                    if(i+1>maxslides_visible){
                      $(element).find('.carousel-indicators>li').eq(i).hide();
                    }
                    else
                    {
                      $(element).find('.carousel-indicators>li').eq(i).show();
                    }
                  }
                }
              }
            })
          }
        );

    }
  };




})(jQuery, Drupal, drupalSettings);


(function($){

  $(document).ready(function(){
    hideSearchButton();

    document.querySelector('.carousel-first-slide-disabled').addEventListener('slide.bs.carousel', function () {
      console.log('noslide carousel slide');
      var carousel = bootstrap.Carousel.getInstance(document.querySelector('.carousel-first-slide-disabled'));
      carousel._config.interval = 6000;
      carousel._config.ride = "carousel";
    });

    $(window).scroll(function(){
        if ($(window).scrollTop() >= 100) {
            $('header').addClass('sticky-header');
        }
        else {
            $('header').removeClass('sticky-header');
        }
    });

    $(window).on('resize', function (){
      hideSearchButton();
    });

    var triggerTabList = [].slice.call(document.querySelectorAll('#ex1 a'))
    triggerTabList.forEach(function (triggerEl) {
      var tabTrigger = new bootstrap.Tab(triggerEl)
      if(tabTrigger) {
        triggerEl.addEventListener('click', function (event) {
          event.preventDefault()
          tabTrigger.show()
        })
      }

    });

    $(".dropdown-toggle-arrow").on("click",function (event){
      event.preventDefault();

      if($(this).hasClass("menu-level-0")){
        $(this).closest("nav").addClass("nav--open");
        $(this).closest(".nav-item").addClass('nav-item--open');
        $(this).closest("nav").find(".menu-level-0-title").text($(this).closest(".nav-item").children('.nav-link').text());
        $(this).closest("nav").find(".menu-level-0-title").attr('href',$(this).closest(".nav-item").children('.nav-link').attr('href'));
        $(this).closest("nav").find(".menu-level-0-title").fadeIn()
        $(this).closest(".nav-item").children('ul').fadeIn();

        console.log( $(this).closest(".nav-item").children('.nav-link').text());
      }
      else {
        if($(this).closest(".nav-item").children('ul').css("display")==='none'){
          $(this).closest("ul").children(".nav-item").find("ul").fadeOut()
          $(this).closest("ul").children(".nav-item").find("a").removeClass("active")

          // $(this).closest("ul").children(".nav-item").find("ul").removeClass()

          $(this).closest(".nav-item").children('ul').fadeIn();
          $(this).addClass("active");
          $(this).closest(".nav-item").children('a').addClass("active")
          // $(this).closest(".nav-item").children('a').css("color","#0072F1");
        }
        else{
          $(this).closest(".nav-item").children('ul').fadeOut();
          $(this).removeClass("active");

          $(this).closest(".nav-item").children('a').removeClass("active");
        }

      }


      $(this).closest("nav").find(".menu-back-button").css("display","block");
    });


    $(".menu-back-button").on("click",function (event){
      event.preventDefault();
      console.log("go back");
      $("nav").removeClass("nav--open");
      $(".nav-item").removeClass("nav-item--open");
      $(".nav-item>ul").fadeOut("slow");
      $(".menu-back-button").css("display","none");
      $(".menu-level-0-title").css("display","none");
    });




    $('#saipem_audio').on('loadedmetadata', function(){
      var duration = $('#saipem_audio')[0].duration;
      if(duration) {
        $('#audio_duration').html(fancyTimeFormat(duration));
      }
    });

    $(".togglePlay").on('click', function(){
      togglePlay();

      $(".saipem--progress-wrapper").show();
    });


  });

})(jQuery);


  var audio = document.getElementById("saipem_audio");
  if(audio) {
    var increment;
    var isPlaying;
    var timer;
    var percent = 0;
    audio.addEventListener("playing", function(_event) {
      var duration = _event.target.duration;
      advance(duration, audio);
    });
    audio.addEventListener("pause", function(_event) {
      clearTimeout(timer);
    });
    var advance = function(duration, element) {
      var progress = document.getElementById("progress_bar");
      increment = 10/duration
      percent = Math.min(increment * element.currentTime * 10, 100);
      progress.style.width = percent+'%'

      jQuery('#audio_duration').html(fancyTimeFormat(element.currentTime));
      startTimer(duration, element);
    }
    var startTimer = function(duration, element){
      if(percent < 100) {
        timer = setTimeout(function (){advance(duration, element)}, 100);
      }
    }
  }


function togglePlay(e) {
  e = e || window.event;
  var btn = e.target;
  if (!audio.paused) {
    btn.classList.remove('active');
    audio.pause();
    isPlaying = false;
  } else {
    btn.classList.add('active');
    audio.play();
    isPlaying = true;
  }
}

function fancyTimeFormat(duration)
{
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + " hr ";
    }

    ret += "" + mins + " min ";
    ret += "" + secs + " sec ";
    return ret;
}
function hideSearchButton(){
  if($(window).width() <= 1100){
    $('.region-mobile-navigation li.nav-item[aria-label="search"]').hide();
  }
}
